import CityGuideCard from './CityGuideCard';
import { CityGuideCardContainerProps } from './CityGuideCard.types';

function CityGuideCardContainer({ neighborhoodGuides }: CityGuideCardContainerProps) {
  return (
    <div className="col-12 col-sm-4 mt-4">
      {neighborhoodGuides &&
        neighborhoodGuides.map((elem, index) => (
          <CityGuideCard header={elem.neighborhood} body={elem.neighborhoodSummary} slug={elem.slug.current} key={index} />
        ))}
    </div>
  );
}
export default CityGuideCardContainer;
